import { render } from "./MotivosRechazoView.vue?vue&type=template&id=adf16428"
import script from "./MotivosRechazoView.vue?vue&type=script&lang=js"
export * from "./MotivosRechazoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__